export default __webpack_public_path__ + "static/media/banner_avator.44a2d100.png";